module.exports = __webpack_public_path__ + "img/dairy.93118853.svg";